import { render, staticRenderFns } from "./fourthTable.vue?vue&type=template&id=1cb3a169&scoped=true"
import script from "./fourthTable.vue?vue&type=script&lang=js"
export * from "./fourthTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3a169",
  null
  
)

export default component.exports